const routeParamRegExp = /:[^/]+/g;

type RouteParam = { [key: string]: string | number };

const replaceRouteParam = (routeParams: RouteParam) => (match: string) => {
  const replacement = match.substring(1);
  return String(routeParams[replacement]);
};

const replaceRouteParams = (pathTemplate: string, routeParams: RouteParam) =>
  pathTemplate.replace(routeParamRegExp, replaceRouteParam(routeParams));

const validateRouteParams = (replacements: string[], routeParams: RouteParam) => {
  replacements.forEach((replacement) => {
    const value = routeParams[replacement];
    const isValid =
      (typeof value === 'string' && value !== '') ||
      (typeof value === 'number' && Number.isFinite(value));
    if (!isValid) {
      throw new Error(
        `routeParam replacement ${replacement} must be a non-empty string or finite number`,
      );
    }
  });
};

interface RouteTemplate<Params> {
  path: string;
  resolve: (routeParams?: Params) => string;
}

export function routeFnFactory<Params = void>(path: string): RouteTemplate<Params> {
  const replacements = Array.from(path.matchAll(routeParamRegExp)).map(([match]) =>
    match.substring(1),
  );

  const resolve = (routeParams?: any) => {
    if (!routeParams) return path;
    process.env.NODE_ENV === 'development' && validateRouteParams(replacements, routeParams);
    return replaceRouteParams(path, routeParams);
  };

  return { path, resolve };
}
